import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { initializeSSE } from "../../redux/slice/sseSlicer";

let sseInitialized = false;

const SSEManager = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    if (!sseInitialized) {
      const cleanup = dispatch(initializeSSE());
      sseInitialized = true;
      
      return () => {
        cleanup();
        sseInitialized = false;
      };
    }
  }, [dispatch]);

  return null;
};

export default SSEManager;